export default "__VITE_ASSET__rBOHlBJk__"